






import FeedbackContent from '@/views/feedback/FeedbackContent.vue';
import ContentPage from '@/components/ContentPage.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ContentPage,
    FeedbackContent,
  },
})
export default class FeedbackView extends Vue {}
